/***
 * Content Provider
 *
 * Provides navigation items and copy
 * eventually will be a service to interface with a CMS
 * **/

import { UserRoleWithCountry } from '../constants'
import { CountryAlphaCodes } from '../constants/countryAlpha2Codes'
import { getCastorEdcHomepageUrl } from '../utils/rwdFollowUpEligibility'

export interface INavigationItem {
  path: string
  title: string
  translationKey: string
  disabled?: boolean
  cmsManaged?: boolean
  onlyAllowForCountryCodes?: string[]
}

export interface ITopTierNavigationItem {
  title: string
  path: string
  disabled: boolean
  isVisibleForMaUser: boolean
  isVisibleForAusMaUser?: boolean
  translationKey?: string
  tooltipTextKey?: string
  customTooltip?: string
  navItems?: INavigationItem[]
  hideForCountriesCode?: string[]
  hideForCountriesCodeWithRole?: UserRoleWithCountry[]
  showNewFeatureHighlight?: boolean
  fixStyle?: boolean
  displayInitialSentence?: boolean
  externalHref?: string
  showForRwdUsersOnly?: boolean
}

export const navigationItems: ITopTierNavigationItem[] = [
  {
    title: 'Home',
    path: '/home',
    translationKey: 'navigation:home',
    isVisibleForMaUser: false,
    isVisibleForAusMaUser: true,
    disabled: false
  },

  {
    title: 'My Dashboard',
    path: '/orders',
    isVisibleForMaUser: true,
    translationKey: 'navigation:my_dashboard',
    tooltipTextKey: 'navigation:orders_tooltip',
    hideForCountriesCode: [CountryAlphaCodes.Australia],
    disabled: false,
    showNewFeatureHighlight: true
  },
  {
    title: 'Products',
    path: '/products/catalogue',
    translationKey: 'navigation:products',
    tooltipTextKey: 'navigation:products_tooltip',
    isVisibleForMaUser: false,
    isVisibleForAusMaUser: true,
    disabled: false
  },
  {
    title: 'Access Programs',
    path: '/programs/access-programs',
    isVisibleForMaUser: true,
    translationKey: 'navigation:access_programs',
    tooltipTextKey: 'navigation:access_programs_tooltip',
    hideForCountriesCodeWithRole: [
      UserRoleWithCountry.AusBase,
      UserRoleWithCountry.AusSuper
    ],
    disabled: false
  },
  {
    title: 'Patients',
    path: '/patients',
    isVisibleForMaUser: true,
    translationKey: 'navigation:patients',
    tooltipTextKey: 'navigation:patients_tooltip',
    hideForCountriesCodeWithRole: [
      UserRoleWithCountry.AusBase,
      UserRoleWithCountry.AusSuper
    ],
    disabled: false,
    showNewFeatureHighlight: true
  },

  {
    title: 'My physicians',
    path: '/programs/my-physicians',
    isVisibleForMaUser: true,
    translationKey: 'navigation:my_physicians',
    tooltipTextKey: 'navigation:physicians_tooltip',
    hideForCountriesCodeWithRole: [
      UserRoleWithCountry.AusBase,
      UserRoleWithCountry.AusSuper
    ],
    disabled: false,
    fixStyle: true
  },

  {
    title: 'Shortages',
    path: '/shortages',
    disabled: true,
    navItems: [
      {
        path: '/shortages/uk-shortages',
        title: 'UK drug shortages',
        disabled: false,
        cmsManaged: true,
        translationKey: 'navigation:uk_shortages',
        onlyAllowForCountryCodes: ['GB']
      },
      {
        path: '/shortages/aus-shortages',
        title: 'ARTG drug shortages',
        disabled: false,
        cmsManaged: true,
        translationKey: 'navigation:aus_shortages',
        onlyAllowForCountryCodes: [CountryAlphaCodes.Australia]
      },
      {
        path: '/shortages/report',
        title: 'Report a shortage',
        disabled: false,
        translationKey: 'navigation:report_a_shortage'
      }
    ],
    isVisibleForMaUser: false,
    isVisibleForAusMaUser: true,
    translationKey: 'navigation:shortages',
    tooltipTextKey: 'navigation:shortages_tooltip',
    customTooltip: 'custom-tooltip',
    fixStyle: true
  },
  {
    title: 'Submit Real World Data',
    path: '/submit-rwd',
    externalHref: getCastorEdcHomepageUrl(),
    isVisibleForMaUser: true,
    disabled: false,
    showForRwdUsersOnly: true
  },
  {
    title: 'Support',
    path: '/support',
    disabled: true,
    navItems: [
      {
        path: '/support',
        title: 'How To Guides',
        disabled: false,
        cmsManaged: true,
        translationKey: 'navigation:account_how_to_guides'
      },
      {
        path: '/about',
        title: 'About Clinigen Direct',
        disabled: false,
        cmsManaged: true,
        translationKey: 'navigation:about_clinigen'
      },
      {
        path: '/about/contact-us',
        title: 'Contact us',
        disabled: false,
        cmsManaged: true,
        translationKey: 'navigation:contact_us'
      }
    ],
    isVisibleForMaUser: true,
    translationKey: 'navigation:account_support',
    tooltipTextKey: 'navigation:support_tooltip',
    customTooltip: 'custom-tooltip',
    fixStyle: true
  },
  {
    title: 'Report an adverse event',
    path: '/products/adverse-event',
    translationKey: 'navigation:report_adverse_event',
    tooltipTextKey: 'navigation:report_adverse_tooltip',
    isVisibleForMaUser: true,
    isVisibleForAusMaUser: true,
    disabled: false,
    fixStyle: true
  }
]
